import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import '../styles/ScrollReveal.css';

function ScrollReveal({
  children,
  as: Component = 'div',
  variant = 'fade-up',
  delay = 0,
  duration,
  className = '',
  threshold,
  rootMargin,
  once = true,
  style = {},
  ...rest
}) {
  const [ref, visible] = useScrollReveal({ threshold, rootMargin, once });

  const classes = [
    'scroll-reveal',
    `scroll-reveal--${variant}`,
    visible ? 'is-visible' : '',
    className
  ]
    .filter(Boolean)
    .join(' ');

  const inlineStyle = {
    ...style,
    '--reveal-delay': `${delay}ms`,
    ...(duration != null ? { '--reveal-duration': `${duration}ms` } : {})
  };

  return (
    <Component ref={ref} className={classes} style={inlineStyle} {...rest}>
      {children}
    </Component>
  );
}

export default ScrollReveal;
